<template>
    <a-modal
        title="详情"
        width='50%'
        :visible="visible"
        :confirmLoading="confirmLoading"
        :destroyOnClose="true"
        @cancel="handleCancel"
        :footer="null"
    >
        <a-spin :spinning="confirmLoading">
            <a-row>
                <a-form layout="inline">
                    <a-col>
                        <!-- 第1行详情 -->
                        <a-row>
                            <a-col :md="24" :sm="24">
                                <a-form-item  label="直播标题">
                                    <span>{{details.title}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col :md="24" :sm="24">
                                <a-form-item  label="直播公告">
                                    <span>{{details.describe}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <!-- 第2行详情 -->
                        <a-row>
                            <a-col :md="12" :sm="24">
                                <a-form-item  label="城市">
                                    <span>{{details.city}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col :md="12" :sm="24">
                                <a-form-item  label="直播间号">
                                    <span>{{details.number}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <!-- 第3行详情 -->
                        <a-row>
                            <a-col :md="12" :sm="24">
                                <a-form-item  label="开始时间">
                                    <span>{{details.createTime}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col :md="12" :sm="24">
                                <a-form-item  label="结束时间">
                                    <span>{{details.endTime}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <!-- 第4行详情 -->
                        <a-row>
                            <a-col :md="24" :sm="24">
                                <a-form-item  label="直播状态">
                                    <span :style="{color: details.liveStreamingStatus==1?'#00c800' : details.liveStreamingStatus==2 ? 'red' : ''}">
                                        {{details.liveStreamingStatus==1?'直播中...' : details.liveStreamingStatus==2 ? '已结束' : ''}}
                                    </span>
                                </a-form-item>
                            </a-col>
                            <!-- <a-col :md="12" :sm="24">
                                <a-form-item  label="观看人数">
                                    <span>{{details.lookPersons}}</span>
                                </a-form-item>
                            </a-col> -->
                        </a-row>
                        <!-- 第5行详情 -->
                        <a-row v-if="details.coverImage">
                            <a-col :md="24" :sm="24">
                                <a-form-item  label="封面图">
                                    <img 
                                        style="height:25%; padding:3px;margin:3px;border:0.5px solid #ccc"
                                        :src="details.coverImage"
                                        @click="showImg()"
                                    >
                                    <!-- 点开大图 -->
                                    <a-modal 
                                        :visible="showBigImg"
                                        :footer="null" 
                                        @cancel="handleCancel_1"
                                    >
                                        <img style="width: 100%;height:100%;padding:10px;" :src="details.coverImage" />
                                    </a-modal>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-form>
            </a-row>
        </a-spin>
    </a-modal>
</template>

<script>
import { liveAdminDetail } from '@/api/modular/mallLiving/liveRoomAdmin'

export default {
    data(){
        return {
            visible: false, //modal框显示状态
            confirmLoading: false,
            id:'',
            details:{},
            form: this.$form.createForm(this),
            showBigImg:false,
        }
    },
    methods:{
        //初始化方法
        detail(record){
            this.visible = true
            this.confirmLoading = true
            //获取详情数据
            setTimeout(()=>{
                liveAdminDetail({id: record.id}).then((res)=>{
                    if(res.success){
                        this.details = res.data
                        this.confirmLoading = false
                    }
                })
            },150)
            
        },
        // 点击遮罩层或右上角叉或取消按钮的操作
        handleCancel(){
            this.visible = false
            this.confirmLoading = false
            this.details = {}
        },
        showImg(){
            this.showBigImg = true
        },
        handleCancel_1(){
            this.showBigImg = false
        }
    }
}
</script>
<style lang="less" scoped>
    .mytable{
        margin-bottom:70px;
        border-collapse:collapse;
        width:100% ;
        height:250px;
        .title {
            background: rgb(207, 248, 248);
            width:20%
        }
        .con{
            width:30%
        }
        td{
            border:2px solid rgb(228, 225, 225);
            padding-left:7px;
            font-size:15px;
        }
    }
    img{
        width:100px;
        height: 50px;
    }
</style>